import { request } from '../api/api';
import { xApiKey, region, locale } from '../config/config';

const config = {
  headers: {
    'x-api-key': xApiKey,
  },
};



export function getSeriesCategories(id) {
  return request(
    'get',
    `/api/plm/product/category-groups/${id}`,
    { locale, region },
    config
  );
}

// #################
export function fetchIndustries() {
  return request(
    'get',
    `/api/plm/product/category-groups`,
    { locale, region },
    config
  );
}


export function getPublishedFiles(params) {
  return request(
    'get',
    `/api/plm/product/published-files`,
    {
      ...params,
      locale, region,
      pageSize: 10,
      pageNumber: 1,
    },
    config
  );
}

export function fileDownload(doc_id) {
  return request(
    'get',
    `/api/common/documents/${doc_id}`,
    { verbose: 100 },
    config
  );
}

export function getSearchResult(params) {
  return request(
    'get',
    `/api/plm/website/product/published-files`,
    { ...params,locale, region, pageSize: 10, pageNumber: 1 },
    config
  );
}


// 修改为接收一个对象参数
export function yuqueDownload({ group_login, book_slug, id }) {
  return request(
    'get',
    `/api/yuque/download?group_login=${group_login}&book_slug=${book_slug}&id=${id}`,
  );
}
